import { useLocation } from 'react-router-dom';
import { List } from '@mui/material';
import { Scrollbar } from 'components/Scrollbar';
import { SidebarData, ResitrictedSidebarData } from './SidebarData';
import { SidebarItem } from './SidebarItem';
import { getAccountDetails } from 'utils/account-details';

export const SidebarList = ({ wide, toggleWide }) => {
  const location = useLocation();

  const accountDetails = getAccountDetails();

  const sideBarItems = accountDetails?.accountStatus === 'Restricted' ? ResitrictedSidebarData : SidebarData;

  const isSelected = (item) => {
    const currentPath = location.pathname;
    // Match exact path or path prefix
    return currentPath === item.path || currentPath.startsWith(`${item.path}/`);
  };

  return (
    <Scrollbar
      sx={{
        height: '85vh',
        '& .simplebar-content': {
          height: '100%',
        },
        '& .simplebar-scrollbar:before': {
          background: '#ebebeb',
        },
      }}
    >
      <List
        component="nav"
        sx={{ padding: '8px 0' }}
        data-testid="sidebar-list"
      >
        {sideBarItems.map((item, index) => (
          <SidebarItem
            item={item}
            key={index}
            wide={wide}
            toggleWide={toggleWide}
            selected={isSelected(item)}
          />
        ))}
      </List>
    </Scrollbar>
  );
};
